import { Component, Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from "../../../_common/_service/user.service";
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { HttpParams } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-editIdbanktransferbeneficiari',
  templateUrl: './editIdbanktransferbeneficiari.component.html',
  styleUrls: ['./editIdbanktransferbeneficiari.component.scss']
})

export class EditIdbanktransferbeneficiariComponent implements OnInit {

  submitted = false;

  EditIdbanktransferbeneficiaryForm: FormGroup;
  currentUser: any;
  token: any;
  countryCode: any;
  loadingspinner: boolean = false;
  editId: any;
  serviceCode: any;
  BankList: any;
  countrytxt: any;
  bank_name: any;
  public BankListFilterCtrl: FormControl = new FormControl();
  protected _onDestroy1 = new Subject<void>();

  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService,
    private _service: CommonService) {


    this.EditIdbanktransferbeneficiaryForm = this.fb.group({
      id: [null],
      beneficiary_fname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_mname: [null, [Validators.pattern("^[a-zA-Z ]*$")]],

      beneficiary_lname: [null, [Validators.required, Validators.pattern("^[a-zA-Z ]*$")]],
      beneficiary_address: [null, [Validators.required]],
      beneficiary_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(1)]],
      beneficiary_email: [null, [Validators.required, Validators.email]],
      beneficiary_state: [null],
      beneficiary_bank_code: [null, [Validators.maxLength(20), Validators.minLength(5)]],
      beneficiary_account_no: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(50)]]
    })

  }


  ngOnInit(): void {

    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    this.countryCode = this.route.snapshot.queryParams.countryCode;


    this.editId = this.route.snapshot.queryParams.editId;
    this.token = this.tokenStorageService.getToken();

    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.BeneficiaryInfoEDITbyId();
      this.getBanklist();
      // listen for search field value changes
      this.BankListFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy1))
        .subscribe(() => {
          this.filterBankList();
        });
    }
    else {
      this._service.callMethodOfSecondComponent();
    }
  }


  Back() {
    this.router.navigate(['/Transfertobank'], { queryParams: { serviceCode: this.serviceCode }, skipLocationChange: true });
  }

  get f() { return this.EditIdbanktransferbeneficiaryForm.controls; }

  BeneficiaryInfoEDITbyId() {
    ;
    this.loadingspinner = true;
    this.authService.GetbanktransferBeneficiaryDetailsbyId(this.editId).subscribe(response => {
      ;
      this.loadingspinner = false;
      debugger
      ////////console.log(response[0]);
      this.f.beneficiary_fname.setValue(response[0].beneficiary_fname);
      this.f.beneficiary_lname.setValue(response[0].beneficiary_lname);
      this.f.beneficiary_address.setValue(response[0].beneficiary_address);
      this.f.beneficiary_phone.setValue(response[0].beneficiary_phone);
      this.f.beneficiary_email.setValue(response[0].beneficiary_email);
      this.f.beneficiary_phone.setValue(response[0].beneficiary_phone);
      this.f.beneficiary_account_no.setValue(response[0].beneficiary_account_no);
      this.f.beneficiary_bank_code.setValue(response[0].beneficiary_bank_code);
      this.f.beneficiary_state.setValue(response[0].beneficiary_state);
      this.f.beneficiary_mname.setValue(response[0].beneficiary_mname);
      this.countrytxt = response[0].beneficiary_country;
      this.bank_name = response[0].beneficiary_bank_name;


    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }

  EditIdbanktransferbeneficiary(post: any) {

    this.submitted = true;
    debugger
    if (this.countrytxt == 'India') {
      if (this.f.beneficiary_bank_code.value == null || this.f.beneficiary_bank_code.value == undefined || this.f.beneficiary_bank_code.value == "") {
        return this.toastr.error('Enter IFS Code', 'Error');
      }
    }


    if (this.countrytxt == 'Australia') {
      if (this.f.beneficiary_state.value == null || this.f.beneficiary_state.value == undefined || this.f.beneficiary_state.value == "") {
        this.f.beneficiary_state.setValidators([
          Validators.required
        ]);
        this.f.beneficiary_state.updateValueAndValidity();
        return this.toastr.error('Enter Beneficiary State', 'Error');
      }
    }
    else {
      this.f.beneficiary_state.setValue(null);
      this.f.beneficiary_state.clearValidators();
      this.f.beneficiary_state.updateValueAndValidity();
    }

    

    if (this.EditIdbanktransferbeneficiaryForm.valid) {
      this.loadingspinner = true;
      post.id = parseFloat(this.editId);
      //post.channel_Code = post.channel_Code.toString();
      debugger
      this.authService.editIdbanktransferBeneficiary(post, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
        debugger
        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.submitted = false;
          this.toastr.success(response.apiMessage, 'Success');
          this.EditIdbanktransferbeneficiaryForm.reset();
        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }


    return;
  }


  getBanklist() {


    this.authService.GetbankDetails(this.countryCode).subscribe(response => {
      debugger
      this.BankList = response.apiData;
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }



  filterBankList() {

    if (this.BankListFilterCtrl.value) {

      return this.BankList.filter((x: { bankName: string; }) => x.bankName.toLowerCase().startsWith(this.BankListFilterCtrl.value.toLowerCase()));
    } else {
      return this.BankList;
    }
  }


}
